import { useTranslation } from 'react-i18next';
import type { Assignment } from '../../api/endpoints.js';
import { currentLocale } from '../../i18n/index.js';
import { formatCalendarDate } from './status.js';

/**
 * Due date, expected date and the recorded delay, shown together.
 *
 * The ORIGINAL due date is always shown when one exists, beside any later
 * expected date, so a delay never quietly replaces the promise it broke. No
 * date is shown as "no date promised" — never as an invented deadline.
 */
export function AssignmentDates({ assignment }: { readonly assignment: Assignment }) {
  const { t } = useTranslation();
  const locale = currentLocale();

  const due = formatCalendarDate(assignment.dueDate, locale);
  const expected = formatCalendarDate(assignment.expectedDate, locale);

  return (
    <div className="min-w-0 text-caption">
      <span className="block text-default-700">
        {due ? t('work.dueOn', { date: due }) : t('work.noDueDate')}
      </span>
      {expected ? (
        <span className="block text-default-600">{t('work.expectedOn', { date: expected })}</span>
      ) : null}
      {assignment.isDelayed ? (
        <span className="block font-medium text-warning-700">{t('work.delayedBadge')}</span>
      ) : null}
      {assignment.latestDelay?.reason ? (
        <span className="block truncate text-default-600">{assignment.latestDelay.reason}</span>
      ) : null}
    </div>
  );
}
